import type { BulletListBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import type { BlockAction } from './BlockActionsMenu'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onToggleSelect: (id: string) => void
}

export function BulletListBlockView({ block, ...rest }: Props) {
  return (
    <BlockShell blockId={block.id} slug={block.slug} {...rest}>
      <ul className="list-disc pl-6 text-sm leading-relaxed">
        {block.items.map((item, i) => (
          <li key={`${block.id}-${i}`}>{item}</li>
        ))}
      </ul>
    </BlockShell>
  )
}
